import { IApplicationState } from '../../types/redux';

/* istanbul ignore next */
export function selectProfilingCookieState(state: IApplicationState): boolean {
  return state.cookies.profiling;
}
